import { render, staticRenderFns } from "./TradeRequest.vue?vue&type=template&id=4e8f0ce2"
import script from "./TradeRequest.vue?vue&type=script&lang=js"
export * from "./TradeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports